<template>
  <v-container>
    <v-layout row class="text-xs-center">
        <v-container style="position: relative;top: 13%;" class="text-xs-center">
            <h1>Get a DID</h1>
            <pre><p id="colorRed">Could not process the details</p></pre>
            <v-btn color="primary"  @click="handleLogin()" primary >Register</v-btn>
        </v-container>
    </v-layout>
  </v-container>
</template>

<script>
import EosService from '@/eosio/EosService';

export default {
  data() {
    return {
      pKey: '',
      eosio: null
    };
  },
  methods: {
    handleLogin: async function() {
      
      if (this.eosio === null) {
        this.eosio = new EosService(
          process.env.VUE_APP_ISSUEDID_NAME,
          process.env.VUE_APP_ISSUEDID_CONTRACT_NAME
        );
      }

      if (!(await this.eosio.connect())) 
      return console.log('Failed to get Scatter account');
      
      try{
        if (
          await this.eosio.transaction('upsert', { user: this.eosio.account.name, publicKey: this.eosio.account.publicKey })
        ) {
          this.$store.commit('loginStatus', true);
          this.$store.commit('Identity', 'individual');
          this.$router.push('individual');
        }
      }catch(error){
        document.querySelector('#colorRed').style.display="inline";
        console.log(error);
      }
    }
  }
};
</script>

<style>
  #colorRed{
    color:red;
    display: none;
  }
</style>
